export default __webpack_public_path__ + "static/media/VDay.7186b3cc.jpg";